<template>
  <div class="fillcontain" v-loading="loading">
    <head-top></head-top>
    <el-row style="margin-top: 20px;">
      <el-col :span="20">
        <el-form :model="formData"  ref="formData" label-width="120px" class="demo-formData">
          <el-form-item label="素材名称">
            <el-input v-model="formData.name" placeholder="请输入素材名称" maxlength="15" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="课程分类">
            <el-select v-model="formData.classify" placeholder="请选择" style="width: 200px" @change="onSelectedDrug">
              <el-option
                v-for="item in option1"
                :key="item.typeId"
                :label="item.typeName"
                :value="item.typeId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="子目录" >
            <el-select v-model="formData.catalog" placeholder="请选择" style="width: 200px" @change="onSelectedDrug1">
              <el-option
                v-for="item in option2"
                :key="item.typeId"
                :label="item.typeName"
                :value="item.typeId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="课程">
            <el-select v-model="formData.curriculum" placeholder="请选择" style="width: 200px">
              <el-option
                v-for="item in option3"
                :key="item.courseId"
                :label="item.courseName"
                :value="item.courseId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="素材内容" prop="name">
            <el-input
              type="textarea"
              :rows="10"
              placeholder="请输入内容"
              v-model="formData.textarea">
            </el-input>
          </el-form-item>
          <div class="but_bot">
            <el-button type="primary" @click="submit()">提交</el-button>
            <el-button type="primary" @click="cancel()">取消</el-button>
          </div>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import headTop from '../components/headTop'
  import { getselectPrimary,getMaterialDetails,getselectSecondType,getselectCourseName,getMaterialEditorial } from "../api/api"
  export default {
    inject: ['reload'],
    data(){
      return {
        formData:{
          name:'',
          curriculum:'',
          textarea:'',
          catalog:'',
          classify:''
        },
        option1:[],
        option2:[],
        option3:[],
        typeName:'',
        loading:false
      }
    },
    components: {
      headTop,
    },

    methods: {
      getcourseType () {
        let params = {
          category: 2
        };
        //获取文字素材一级分类
        getselectPrimary(params).then(res => {
          this.option1 = res
          // this.total = res.total
        }).catch(error => {
          console.log(error);
        })

        let param = {
          category: 2,
          materialId: this.$route.query.materialId,
          parentId: this.$route.query.parentId,
          typeId: this.$route.query.typeId
        };
        //获取文字素材内容详情
        getMaterialDetails(param).then(res => {
          this.formData.name = res.materialName
          this.formData.classify = res.parentId
          this.formData.catalog = res.typeId
          this.formData.curriculum = res.classifyId
          this.formData.textarea = res.materialContent.replace(/\/n/g, "\n").replace(/\/t/g, " ")
        }).catch(error => {
          console.log(error);
        })
        getselectSecondType(param).then(res => {
          this.option2 = res
        }).catch(error => {
          console.log(error);
        })
        getselectCourseName(param).then(res => {
          this.option3 = res
        }).catch(error => {
          console.log(error);
        })
      },
      onSelectedDrug () {
        let param = {
          category: 2,
          parentId:this.formData.classify,
        };
        //获取文字素材二级分类
        getselectSecondType(param).then(res => {
          this.option2 = res
        }).catch(error => {
          console.log(error);
        })
      },
      onSelectedDrug1 () {
        let param = {
          category: 2,
          typeId:this.formData.catalog,
        };
        //获取文字素材三级级分类
        getselectCourseName(param).then(res => {
          this.option3 = res
        }).catch(error => {
          console.log(error);
        })
      },
      //文字素材内容修改
      submit(){
        if (this.formData.name == '' || this.formData.textarea == ''|| this.formData.curriculum == ''){
          this.$message({
            type: 'error',
            message: '请填写完整信息'
          });
        } else {
          this.loading = true
          let params = {
            classifyId: this.formData.curriculum,
            materialId: this.$route.query.materialId,
            materialName:this.formData.name,
            operationId:JSON.parse(sessionStorage.getItem('user')).id,
            materialContent:(this.formData.textarea.replace(/\n/g, "/n")).replace(/ /g, "/t")
          };
          getMaterialEditorial(params).then((res)=>{
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.loading = false
              this.formData = {}
              this.$router.push('materrial')
            }else{
              this.$message({
                type: 'error',
                message: '素材名称只能输入中英文以及数字'
              });
            }
          }).catch(error => {
            console.log(error);
          })
        }
      },
      cancel(){
        this.reload()
        this.formData = {}
        this.$router.push('materrial')
      }
    },
    activated(){
      this.getcourseType();
    },
  }
</script>

<style lang="less">
  @import '../style/mixin';
  .el-textarea__inner{
    width: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/page/materialInfo.vue